export default "__VITE_ASSET__DKI4IiL2__"